import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const { tag, h1, slogan, description, stats, primaryCta, secondaryCta } = heroData;

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20gradient%20background%20with%20warm%20red%20orange%20and%20deep%20crimson%20tones%2C%20dynamic%20flowing%20shapes%2C%20modern%20entertainment%20media%20aesthetic%2C%20smooth%20color%20transitions%2C%20energetic%20and%20bold%20visual%20style%2C%20dark%20edges%20with%20bright%20center%20glow&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="52吃瓜网首页背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-bold mb-4 whitespace-nowrap">
              {tag}
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              {h1}
            </h1>

            <p className="text-base md:text-lg text-white/80 font-medium mb-3">
              {slogan}
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              {description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/60">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={primaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                {primaryCta.text}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={secondaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 hover:border-white/60 text-white font-medium text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                {secondaryCta.text}
                <i className="ri-fire-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20with%20vibrant%20magazine%20cover%20style%2C%20bold%20typography%20elements%2C%20glamorous%20celebrity%20silhouettes%2C%20breaking%20news%20aesthetic%2C%20red%20and%20gold%20color%20scheme%2C%20dynamic%20composition%2C%20modern%20media%20design%20with%20dramatic%20lighting%20effects&width=700&height=800&seq=hero-visual&orientation=portrait"
                  alt="52吃瓜网最新爆料与娱乐八卦聚合"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-accent-500 text-background-50 px-3 py-2 rounded-lg text-xs font-bold shadow-lg whitespace-nowrap">
                实时更新 · 吃瓜不停
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}